import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import { trackScreenView, trackClick } from "@/lib/gtag";
import BBFFooter from "@/components/BBFFooter";

import "../../App.css";

export default function PressHub() {
  const sectionRef = useRef(null);

  // Track page load
  useEffect(() => {
    if (sectionRef.current) {
      trackScreenView("PressHub");
    }
  }, []);

  // Track scroll to bottom
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 50
      ) {
        trackClick("PressHub BottomReached");
        window.removeEventListener("scroll", handleScroll);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <main className="press-container" ref={sectionRef}>
      <section className="press-hero">
        <div className="press-hero__bg">
          <img
            src="/static/branding/butler-brief-banner.png"
            alt=""
            aria-hidden="true"
          />
        </div>

        {/* Center the hero content */}
        <div className="press-hero__content" style={{ textAlign: "center" }}>
          <h1>Press & Media</h1>
          <p className="deck">
            Official releases, resources, and contact information.
          </p>

          <div
            className="press-hero__actions"
            style={{ display: "flex", justifyContent: "center", gap: "1rem" }}
          >
            {/* Butler Bullseye Release */}
            <Link
              to="/press/001-butler-bullseye"
              className="btn"
              onClick={() => {
                trackClick("PressHub Hero ButlerBullseye");
              }}
            >
              Butler Bullseye Release
            </Link>

            {/* All Inquiries via email */}
            <a
              href="mailto:support@butlerbrief.com?subject=Press%20Inquiry&body=Hello%20Team%2C%0A%0AI%27m%20reaching%20out%20with%20a%20press%20inquiry.%20Please%20get%20back%20to%20me.%0A%0AName:%20%0AOrganization:%20%0ATitle:%20%0A%0AThanks!"
              className="btn btn-outline"
              onClick={() => {
                trackClick("PressHub Hero AllInquiries");
              }}
            >
              All Inquiries
            </a>

            {/* Request Media Kit via email */}
            <a
              href="mailto:support@butlerbrief.com?subject=Media%20Kit%20Request&body=Hello%20Team%2C%0A%0AI%27d%20like%20to%20request%20the%20latest%20Media%20Kit%20for%20The%20Butler%20Brief.%0A%0AName:%20%0AOrganization:%20%0ATitle:%20%0A%0AThanks!"
              className="btn btn-outline"
              onClick={() => {
                trackClick("PressHub Hero RequestMediaKit");
              }}
            >
              Request Media Kit
            </a>
          </div>

          {/* Media Kit note */}
          <p style={{ marginTop: "1rem", fontSize: "0.9rem" }}>
            Request the Media Kit{" "}
            <span style={{ whiteSpace: "nowrap" }}>(latest v2025-10-10)</span>{" "}
            to <strong>see the Butler Bullseye</strong>. <br />
            It includes the Core Complaint, timelines, images, and an author
            bio/headshot for editorial use.
          </p>
        </div>
      </section>

      <section className="press-list" style={{ textAlign: "left" }}>
        {/* Packet 1A */}
        <article className="press-card">
          <p className="kicker">MEDIA ADVISORY — FOR IMMEDIATE RELEASE</p>
          <h2>
            <Link
              to="/press/001-butler-bullseye"
              onClick={() => {
                trackClick("PressHub ButlerBullseye ViewFullRelease");
              }}
            >
              Criminal Complaints Filed: The “Butler Bullseye” and Allegations
              Against Joe Biden and the Rosemont Network
            </Link>
          </h2>
          <p className="meta">Packet 1A · August 22, 2025</p>
          <p className="summary">
            <strong>Boston, MA —</strong> Private complaints filed in Butler &
            Luzerne Counties allege the Rosemont Network engineered the “Butler
            Bullseye” — a symbolic, geographic kill zone where President Trump
            was nearly assassinated (7/13/24). Full complaint and timelines
            inside the Media Kit.
          </p>
          <div
            className="links"
            style={{ display: "flex", justifyContent: "center", gap: "1rem" }}
          >
            <Link
              className="btn"
              to="/press/001-butler-bullseye"
              onClick={() => {
                trackClick("PressHub ButlerBullseye ViewFullReleaseBtn");
              }}
            >
              View Full Release
            </Link>
            <a
              className="btn"
              href="https://robertantonellis.substack.com/p/criminal-complaints-filed-the-butler?r=69i5m6"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                trackClick("PressHub ButlerBullseye Substack");
              }}
            >
              Full Article on Substack
            </a>
          </div>
        </article>

        {/* Packet 2A */}
        <article className="press-card">
          <p className="kicker">MEDIA ADVISORY — FOR IMMEDIATE RELEASE</p>
          <h2>
            <Link
              to="/press/002-year-of-23"
              onClick={() => {
                trackClick("PressHub Hitler's Coup ViewFullRelease");
              }}
            >
              The Year of 23: From Hitler’s Coup to Biden’s “Bigger Lie”
            </Link>
          </h2>
          <p className="meta">Packet 2A · August 22, 2025</p>
          <p className="summary">
            <strong>Boston, MA —</strong> Complaints allege Biden revived
            Hitler’s playbook and link the Sept 11, 2023 $6B Iran funds release
            to the Oct 7, 2023 Hamas attack as a centennial “hat tip.” Analysis
            and exhibits inside the Media Kit.
          </p>
          <div
            className="links"
            style={{ display: "flex", justifyContent: "center", gap: "1rem" }}
          >
            <Link
              className="btn"
              to="/press/002-year-of-23"
              onClick={() => {
                trackClick("PressHub Hitler's Coup ViewFullReleaseBtn");
              }}
            >
              View Full Release
            </Link>
            <a
              className="btn"
              href="https://robertantonellis.substack.com/p/the-year-of-23-from-hitlers-coup?r=69i5m6"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                trackClick("PressHub Hitler's Coup Substack");
              }}
            >
              Full Article on Substack
            </a>
          </div>
        </article>

        <article className="press-card">
          <p className="kicker">COMING SOON</p>
          <h2>Additional Packets</h2>
          <p className="summary">
            Check back regularly for updates, or{" "}
            <Link
              to="/contact?mode=media-kit"
              onClick={() => {
                trackClick("PressHub Card3 DownloadMediaKit");
              }}
            >
              download the Media Kit
            </Link>{" "}
            and have future press releases delivered to your inbox.
          </p>
        </article>
      </section>

      <BBFFooter />
    </main>
  );
}
